import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";
import frogLogo from "@/assets/frog-knows-natives-logo-approved.png";

const Footer = () => {
  return (
    <footer className="bg-muted/30 border-t border-border/40">
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <img src={frogLogo} alt="Frog Knows Natives" width={60} height={40} loading="lazy" decoding="async" className="h-10 w-auto object-contain" />
              <div>
                <span className="font-display text-lg font-semibold block">{BRAND.APP_NAME}</span>
                <span className="text-xs text-muted-foreground">{BRAND.APP_TAGLINE}</span>
              </div>
            </Link>
            <p className="text-sm text-muted-foreground max-w-xs">
              Frog Knows Natives helps homeowners build native gardens using location, sunlight, soil, and ecological guidance.
            </p>
          </div>

          {/* Product */}
          <div>
            <div className="font-display font-semibold mb-4" role="heading" aria-level={2}>Product</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/how-it-works" className="text-muted-foreground hover:text-foreground transition-colors">How It Works</Link></li>
              <li><Link to="/what-you-get" className="text-muted-foreground hover:text-foreground transition-colors">What You Get</Link></li>
              <li><Link to="/pricing" className="text-muted-foreground hover:text-foreground transition-colors">Pricing</Link></li>
              <li><Link to="/examples" className="text-muted-foreground hover:text-foreground transition-colors">Examples</Link></li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <div className="font-display font-semibold mb-4" role="heading" aria-level={2}>Community</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/ecosystem" className="text-muted-foreground hover:text-foreground transition-colors">Ecosystem</Link></li>
              <li><Link to="/plant-map" className="text-muted-foreground hover:text-foreground transition-colors">Plant Map</Link></li>
              <li><Link to="/garden-gallery" className="text-muted-foreground hover:text-foreground transition-colors">Garden Gallery</Link></li>
              <li><Link to="/gallery" className="text-muted-foreground hover:text-foreground transition-colors">Community Gallery</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <div className="font-display font-semibold mb-4" role="heading" aria-level={2}>Support</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="text-muted-foreground hover:text-foreground transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <div className="font-display font-semibold mb-4" role="heading" aria-level={2}>Legal</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/refunds" className="text-muted-foreground hover:text-foreground transition-colors">Refund & Cancellation</Link></li>
              <li><Link to="/disclaimer" className="text-muted-foreground hover:text-foreground transition-colors">Garden Plan Disclaimer</Link></li>
              <li><Link to="/image-credits" className="text-muted-foreground hover:text-foreground transition-colors">Image Credits</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-border/40 space-y-3">
          <p className="text-xs text-muted-foreground text-center max-w-2xl mx-auto leading-relaxed">
            {BRAND.DISCLAIMER}{" "}
            <Link to="/terms" className="underline underline-offset-2 hover:text-foreground transition-colors">
              Terms of Service
            </Link>
          </p>
          <p className="text-xs text-muted-foreground text-center">
            {BRAND.COPYRIGHT}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
